import React from 'react';
import { Shield, LogOut } from 'lucide-react';
import { endImpersonation } from '../lib/firebase';

interface ImpersonationBannerProps {
  adminEmail: string;
  targetEmail: string;
}

export default function ImpersonationBanner({ adminEmail, targetEmail }: ImpersonationBannerProps) {
  return (
    <div className="bg-amber-500 text-white px-4 py-3 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <Shield className="w-5 h-5" />
          <div>
            <p className="font-semibold text-sm">
              Admin Mode: Viewing as {targetEmail}
            </p>
            <p className="text-xs text-amber-100">
              Logged in as admin: {adminEmail}
            </p>
          </div>
        </div>
        <button
          onClick={endImpersonation}
          className="inline-flex items-center px-4 py-2 bg-white text-amber-600 hover:bg-amber-50 rounded-lg font-medium transition-colors shadow-sm"
        >
          <LogOut className="w-4 h-4 mr-2" />
          Exit Impersonation
        </button>
      </div>
    </div>
  );
}
